import { VARIANTS } from '@components/ArtBoard/Node/constants'
import cx from 'classnames'
import type React from 'react'

import { DEFAULT_PAGE_NAME } from '@/constants/defaultNames'
import type { TreeItemVariants } from '@/types'
import css from './Name.module.scss'

type Props = {
  name: string
  variant: TreeItemVariants
  isProjectNeutral?: boolean
}

const Name: React.FC<Props> = ({ name, variant, isProjectNeutral }) => (
  <div
    className={cx(css.container, {
      [css.ghost]: variant === VARIANTS.GHOST,
      [css.dashed]: variant === VARIANTS.FRAME,
      [css.neutral]: isProjectNeutral,
    })}
  >
    <div className={css.name}>{name || DEFAULT_PAGE_NAME}</div>
  </div>
)

export default Name
